import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { withConfig } from 'src/withConfig';

const setStatusWrapper = (isMini: boolean, isFullScreen: boolean, theme: EmotionTheme): SerializedStyles => {
    if (isMini && isFullScreen) {
        return css`
            font-size: ${theme.star.fontSize.small};
            gap: 8px;
            height: 32px;
            @media ${theme.star.mediaQuery.tablet} {
                gap: 32px;
                height: 48px;
            }
        `;
    }

    if (isMini) {
        return css`
            font-size: ${theme.star.fontSize.xSmall};
            gap: 0;
            height: 32px;
        `;
    }

    if (isFullScreen) {
        return css`
            font-size: ${theme.star.fontSize.small};
            gap: 16px;
            height: 32px;
            @media ${theme.star.mediaQuery.tablet} {
                gap: 32px;
                height: 48px;
            }
        `;
    }

    return css`
        font-size: ${theme.star.fontSize.small};
        height: 32px;
        gap: 16px;
        @media ${theme.star.mediaQuery.tablet} {
            height: 48px;
            gap: 32px;
        }
    `;
};

interface GameStatusWrapperPropsType {
    isFullScreen: boolean;
    isMini: boolean;
}

export const GameStatusWrapper = withConfig(theme => styled('div', { label: 'GameStatusWrapper' })<GameStatusWrapperPropsType>`
    ${({ isMini, isFullScreen }): SerializedStyles => setStatusWrapper(isMini, isFullScreen, theme)}
    background: ${theme.star.casino.casinoMini.colors.bgQuinary};
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    width: 100%;
`);

export const PropertyWrapper = withConfig(theme => styled('div', { label: 'PropertyWrapper' })`
    display: flex;
    line-height: ${theme.star.lineHeight[200]};
    margin-left: 0;
`);

export const PropertyLabel = withConfig(theme => styled('div', { label: 'PropertyLabel' })`
    color: ${theme.star.casino.txtColor};
    font-weight: ${theme.star.fontWeight.bold};
`);

export const PropertyValue = withConfig(theme => styled('div', { label: 'PropertyValue' })`
    margin-left: 8px;
    color: ${theme.star.casino.txtColorSecondary};
    font-weight: ${theme.star.fontWeight.bold};
`);

export const PropertyValueCounter = styled(PropertyValue, { label: 'PropertyValueCounter' })`
    width: 60px;
`;
